const menuLinks = [
	{
		id: "0",
		links: "#home",
		name: "home",
	},
	{
		id: "1",
		links: "#bscscan",
		name: "BSCSCAN",
	},
	{
		id: "2",
		links: "#staking",
		name: "staking",
	},
	{
		id: "3",
		links: "#beta-nft",
		name: "beta NFT",
	},
	{
		id: "4",
		links: "#audit-kyc",
		name: "Audit And KYC",
	},
	{
		id: "5",
		links: "#whitepaper",
		name: "Whitepaper",
	},
];

export default menuLinks;
